module.exports = __webpack_public_path__ + "img/iphone-orange.39fe99ff.png";